import { MESSAGE_STATUS } from '@wa/shared';

/**
 * Delivery state, drawn the way WhatsApp draws it — a clock while queued, one
 * tick sent, two delivered, two blue read. Agents read these without being
 * taught, which is the whole reason to follow the convention.
 *
 * The status is also exposed as text to assistive technology, because colour
 * and tick count alone are not accessible.
 */
export function Ticks({ status }: { status: number }) {
  const label = MESSAGE_STATUS[status] ?? String(status);

  if (status === 4) {
    return <span className="text-micro font-medium text-(--color-bad)">failed</span>;
  }

  if (status === 0) {
    return (
      <svg viewBox="0 0 16 16" width="14" height="14" role="img" aria-label={label} className="text-(--color-tick)">
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.3" />
        <path d="M8 4.6V8l2.2 1.4" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      </svg>
    );
  }

  const isRead = status === 3;
  const isDouble = status >= 2;

  return (
    <svg
      viewBox="0 0 20 14"
      width="17"
      height="12"
      role="img"
      aria-label={label}
      className={isRead ? 'text-(--color-tick-read)' : 'text-(--color-tick)'}
    >
      <path d="M2 7.6 5.2 11 11.6 3.4" fill="none" stroke="currentColor" strokeWidth="1.6"
            strokeLinecap="round" strokeLinejoin="round" />
      {isDouble && (
        <path d="M8 7.6 11.2 11 17.6 3.4" fill="none" stroke="currentColor" strokeWidth="1.6"
              strokeLinecap="round" strokeLinejoin="round" />
      )}
    </svg>
  );
}
